.actions-wrapper {
  padding: calc(4 * var(--spacer)) calc(5 * var(--spacer));
}

#integrity-monitor-pause-targets {
  #integrity-monitor-pause-targets-value {
    font-size: var(--body-size-medium);
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    font-weight: 400;
    line-height: 16px;
  }
}

gz-labeled-content {
  height: fit-content;

  &::part(label) {
    width: 174px;
    padding-top: 6px;
  }
}

gz-chips-generator-input {
  --chip-list-width: 600px;
}
